<template>
<m-pageframe
    title="Search RedChirp Users"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px;"
>

    <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        style="margin-bottom: 15px; margin-top: -15px;"
        v-on:input="update()"
        autofocus
        autocomplete="off"
     >

    <span
        slot="append-outer"
    >
        <v-menu 
            bottom 
            offset-y  
        >
            <template v-slot:activator="{ on }">

                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                
            </template>

            <v-list>
                <v-list-item
                    v-on:click="onClickExportToExcel"
                >
                    <v-list-item-title>Export to Excel...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>

    </span>

    </v-text-field>

    <v-select
        label="Integration Enabled"
        :items="integration_choices"
        v-model="search_integration"
        v-on:change="update()"
    />

    <v-data-table 
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        hide-default-footer 
    
    >
        <template v-slot:item.is_system_admin="{ item }"> 
            <v-simple-checkbox v-model="item.is_system_admin" disabled></v-simple-checkbox>
        </template>

        <template v-slot:item.is_organization_admin="{ item }"> 
            <v-simple-checkbox v-model="item.is_organization_admin" disabled></v-simple-checkbox>
        </template>

        <template v-slot:item.is_archived="{ item }">
            <v-simple-checkbox v-model="item.is_archived" disabled></v-simple-checkbox>
        </template>

        <template v-slot:item.is_organization_archived="{ item }">
            <v-simple-checkbox v-model="item.is_organization_archived" disabled></v-simple-checkbox>
        </template>

        <template v-slot:item.has_set_password="{ item }">
            <v-simple-checkbox v-model="item.has_set_password" disabled></v-simple-checkbox>
        </template>

         <template v-slot:item.integrations="{ item }">
            {{$rc.pretty(item.active_integrations, 'comma_list')}}
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y
            >
                
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        mdi-dots-vertical-circle-outline
                    </v-icon>
                </template>

                <v-list>
                    <v-list-item
                        v-on:click="onAccountSettings(item)"
                    >
                        <v-list-item-title>Account settings...</v-list-item-title>
                    </v-list-item>
                    
                    <v-list-item
                        v-on:click="sendPasswordResetLink(item)"
                    >
                        <v-list-item-title>Send setup account / reset password link...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="onOrganizationSettings(item)"
                    >
                        <v-list-item-title>Organization settings...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="onClickExportToExcelFromOneOrg($event, item)"
                    >
                        <v-list-item-title>Export {{item.organization_label}} users to excel...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="onViewEmployeeFollowing($event, item)"
                    >
                        <v-list-item-title>Following...</v-list-item-title>
                    </v-list-item>

                     <v-list-item
                        v-on:click="onClickGoToWelcomePage(item)"
                    >
                        <v-list-item-title>Go to welcome page...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="onClickMultiOrg(item)"
                    >
                        <v-list-item-title>Access to multiple organizations...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="onSignInAs(item)"
                    >
                        <v-list-item-title>Sign In As...</v-list-item-title>
                    </v-list-item>

                    

                </v-list>
            </v-menu>

        </template>

    </v-data-table>


<m-text-password-reset-link-dialog
    ref="text-password-reset-link-dialog"
/>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            search: null,
            results: [],

            headers: [
                { text: 'Username', value: 'username' },
                { text: 'Name', value: 'employee_label' },
                { text: 'Organization', value: 'organization_label' },
                { text: 'System Admin', value: 'is_system_admin' },
                { text: 'Organization Admin', value: 'is_organization_admin' },
                { text: 'Archived', value: 'is_archived' },
                { text: 'Has Password', value: 'has_set_password' },
                { text: 'Integrations', value: 'integrations' },
                { text: 'Action', value: 'action', align: 'center' }
            ],

            integration_choices: this.$rc.enumChoices('integration_name'),

            search_integration: 'any_enum_value',
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {


        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            let search = {
                'full_text' : this.search,
            };

            if ( this.search_integration != null && this.search_integration != 'any_enum_value' )
            {
                search.active_integrations = { 'type': 'contains', 'value' : this.search_integration };
            }


            this.$rc.rest(
                'LIST: /api/v1/admin/search-employees',
            
                search,
            
                (data) => {
                    this.results = data.results;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },
        

        onOrganizationSettings(item)
        {
            this.$router.push(
                { 
                    name: 'settings-organization', 
                    params: { 
                        'organization_id': item.organization_id,
                    } 
                }
            );
        },

        onAccountSettings(item)
        {
            this.$router.push(
                { 
                    name: 'settings-account', 
                    params: { 
                        'employee_id': item.employee_id,
                    } 
                }
            );
        },



        onViewEmployeeFollowing(event, item)
        {
            this.$router.push({
                'name': 'employee-following',
                'params' : {
                    'employee_id' : item.employee_id,
                }
            }).catch(e=>{}); // swallow any exception
        },
        
        onSignInAs(item)
        {
            if ( item.is_archived )
            {
                this.$rc.alert('Unable to sign in as', 'You may not sign in as an archived user');
                return;
            }

            this.$rc.newSignInAs(
                {
                    'organization_id': item.organization_id,
                    'employee_id': item.employee_id,
                }
            );
        },

        sendPasswordResetLink(item)
        {
            this.$refs['text-password-reset-link-dialog'].showDialog(item.employee_id);
        },


        onClickExportToExcel()
        {
            this.$rc.excelExport(
                    'EXPORT: /api/v1/admin/employees/excel-export',
                    {
                    }
                );
        },

        onClickExportToExcelFromOneOrg(event, item)
        {
             this.$rc.excelExport(
                    'EXPORT: /api/v1/admin/employees/excel-export',
                    {
                        'limit_to_organization_id': item.organization_id,
                    }
                );
        },

        onClickGoToWelcomePage(item)
        {
            this.$router.push({
                'name': 'welcome_ordinary_user',
                'params' : {
                    'employee_id': item.employee_id,
                }
            });
        },

        onClickMultiOrg(item)
        {
            this.$router.push({
                'name': 'admin-multi-org-employee',
                'params' : {
                    'employee_id': item.employee_id,
                }
            });  
        },
    },
}
</script>

<style lang="scss" scoped>

</style>